module.exports = __webpack_public_path__ + "img/st-cb6-1-000.5a5533d3.gif";